import { RequestConfig } from '~/common/services/requests';
import { AnyDocument, WorkflowState } from '../../../../types';
import { buildHeadersFromDocumentParams } from '../../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplication = async (
  constructGet: ConstructGet,
  uuid: string,
  documentParams: DocumentParams,
  params?: RequestConfig['params'],
): Promise<
  NonPaginatedResponse<AnyDocument & { meta?: WorkflowState }> | undefined
> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}`, {
    params,
    headers: buildHeadersFromDocumentParams(documentParams),
  });
